export default __webpack_public_path__ + "static/media/long-arrow.08874810.svg";